import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { OwlLogo } from './OwlLogo';

export interface EmptyStateProps {
  // Иконка по умолчанию — совёнок-маскот. Передайте свою для тематического
  // empty state (например, ошибка или специальный сценарий).
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-[20px] border border-dashed border-stroke bg-bg-soft/40 px-6 py-12 text-center animate-enter-spring',
        className,
      )}
    >
      <div className="relative">
        {/* Soft glow behind the mascot — subtle Apple Music–style */}
        <div
          className="absolute inset-0 rounded-full bg-brand-gradient opacity-20 blur-xl"
          aria-hidden
        />
        <div className="relative flex h-20 w-20 items-center justify-center">
          {icon ?? <OwlLogo size={72} />}
        </div>
      </div>
      <h3 className="text-lg font-semibold tracking-tight text-text">{title}</h3>
      {description && (
        <p className="max-w-sm text-sm text-text-muted">{description}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
